import { render, staticRenderFns } from "./VendorDialog.vue?vue&type=template&id=234fda5a"
import script from "./VendorDialog.vue?vue&type=script&lang=ts"
export * from "./VendorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports